"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Styling_1 = require("../../Styling");
var GlobalClassNames = {
    root: 'ms-DocumentCardLogo'
};
exports.getStyles = function (props) {
    var theme = props.theme, className = props.className;
    var palette = theme.palette;
    var classNames = Styling_1.getGlobalClassNames(GlobalClassNames, theme);
    return {
        root: [
            classNames.root,
            {
                fontSize: '32px',
                color: palette.themePrimary,
                display: 'block',
                padding: '16px 16px 0 16px'
            },
            className
        ]
    };
};
//# sourceMappingURL=DocumentCardLogo.styles.js.map


//////////////////
// WEBPACK FOOTER
// ./~/office-ui-fabric-react/lib-commonjs/components/DocumentCard/DocumentCardLogo.styles.js
// module id = 969
// module chunks = 0